import { FsTimeAttackScoringSum } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoringSum";
import { TimeAttackScoringBase } from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoring";
import { TimeAttackScoringSum } from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoringSum";

export const mapTimeAttackScoringSum = (
  base: TimeAttackScoringBase,
  fsModel: FsTimeAttackScoringSum
): TimeAttackScoringSum | undefined => {
  return {
    ...base,
    type: "Sum",
  };
};
